import { render } from "./DocumentDataManager.vue?vue&type=template&id=c27f39d2"
import script from "./DocumentDataManager.vue?vue&type=script&lang=js"
export * from "./DocumentDataManager.vue?vue&type=script&lang=js"

import exportComponent from "/www/wwwroot/demo-plus.centrodeglaucoma.com/darmin-plus-modular/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__